import { useContext, useEffect, useState } from "react";
import MyProfileSectionTitle from "../section-title";
import useToggle from "../../../../hooks/useToggle";
import { AmbassadorProfileContext } from "..";
import { Grid, Stack, Typography } from "@mui/material";
import { useAppDispatch } from "../../../../store";
import { getUserProfile, updateUserProfile } from "../../../../api/profile";
import ModalBox from "../../../../components/modal";
import AddOrUpdateIntrested from "./add-or-update";
import IntrestedBlock from "./intrested-block";

export default function AmbassadorIntrestedIn() {
  const [openEditModal, setOpenEditModal] = useToggle(false);
  const { data, editMode } = useContext(AmbassadorProfileContext);
  const [selectedIntrested, setSelectedIntrested] = useState(null);
  const dispatch = useAppDispatch();

  useEffect(() => {
    selectedIntrested && setOpenEditModal();
  }, [selectedIntrested]);

  const [deletingLabel, setDeletingLabel] = useState<string | null>(null);

  const onDelete = async (priority) => {
    setDeletingLabel(priority?.label ?? null);
    try {
      const tmpPriority = Array.isArray(data?.topics)
        ? [...data?.topics].filter((t) => t?.label !== priority?.label)
        : [];
      await dispatch(
        updateUserProfile({
          topics: tmpPriority,
        })
      );
      dispatch(getUserProfile());
    } finally {
      setDeletingLabel(null);
    }
  };

  const onSubmit = () => {
    setOpenEditModal();
    setSelectedIntrested(null);
    dispatch(getUserProfile());
  };

  const onClose = () => {
    setOpenEditModal();
    setSelectedIntrested(null);
  };

  const topics = data?.topics
    ? Array.isArray(data?.topics)
      ? data?.topics
      : []
    : [];

  return (
    <Stack gap={2}>
      <MyProfileSectionTitle
        title={"Areas of Interest"}
        onAddClick={setOpenEditModal}
        editable={false}
        operation={"ADD"}
      />

      {topics && !topics?.length && (
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {`Not available`}
        </Typography>
      )}

      {topics && topics?.length > 0 && (
        <Grid container spacing={2}>
          {topics?.map((intrested, intrestedIndex) => (
            <Grid item xs={12} sm={4} key={`intrestedlist-${intrestedIndex}`}>
              <IntrestedBlock
                data={intrested}
                editable={editMode}
                onEditClick={() => setSelectedIntrested(intrested)}
                onDeleteClick={() => onDelete(intrested)}
                deleteLoading={deletingLabel === intrested?.label}
              />
            </Grid>
          ))}
        </Grid>
      )}

      {openEditModal && (
        <ModalBox title={"New Product"} onClose={onClose} showFooter={false}>
          <AddOrUpdateIntrested
            key={selectedIntrested?.label ?? "new"}
            onSubmit={onSubmit}
            onCancel={onClose}
            selectedIntrested={selectedIntrested}
            data={data}
          />
        </ModalBox>
      )}
    </Stack>
  );
}
